import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexCol } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { RequestTitle, RequestStatus } from './RequestTitle';
import { OrderDetailItems } from './OrderDetailItems';
import { getRequestDetailInfo } from '../../../utilities/selectors';
import { Button } from '../General/Button';
import { SummaryValue } from '../Cart/Summary/SummaryValue';
import { formatPriceToString, round } from '../../../utilities';

interface Props {
  data: any;
  isB2B?: boolean;
}

function OrderDetail({ data, isB2B }: Props) {
  const {
    orderId,
    vs,
    orderStatusReadable,
    items,
    totalPrice,
    totalPriceWithoutVat,
    currency,
    vat,
    yourNr,
    deliveryPrice,
    paymentPrice,
    ordernr,
    deliveryPriceWithoutVat,
    paymentPriceWithoutVat,
    note,
  } = getRequestDetailInfo(data);
  let totalItemsPrice = 0;
  let totalItemsPriceWithoutVat = 0;
  if (items) {
    items.map(i => {
      if (!i.is_meta_item) {
        totalItemsPrice += i.totalprice;
        totalItemsPriceWithoutVat += i.totalprice_without_vat;
      }
    });
  }

  return (
    <Wrapper>
      <RequestTitle
        title={`${__('Objednávka č.')} ${ordernr}`}
        statusText={orderStatusReadable}
        note={note}
        status={
          orderStatusReadable === 'Prijatá'
            ? RequestStatus.WAITING
            : orderStatusReadable === 'Spracováva sa'
            ? RequestStatus.INWORK
            : RequestStatus.DONE
        }
      />
      <OrderDetailItems items={items} hasMoreInfo={true} isB2B={isB2B} />
      <BottomWrapper>
        <SummaryValue
          title={__('Cena tovaru s DPH')}
          value={formatPriceToString(round(totalItemsPrice, 2), currency)}
        />
        <SummaryValue
          title={
            isB2B ? __('Cena za dopravu bez DPH') : __('Cena za dopravu s DPH')
          }
          value={formatPriceToString(
            round(isB2B ? deliveryPriceWithoutVat : deliveryPrice, 2),
            currency,
          )}
        />
        <SummaryValue
          title={
            isB2B ? __('Cena za platbu bez DPH') : __('Cena za platbu s DPH')
          }
          value={formatPriceToString(
            round(isB2B ? paymentPriceWithoutVat : paymentPrice, 2),
            currency,
          )}
        />
        <SummaryValue
          title={__('DPH')}
          value={formatPriceToString(vat, currency)}
        />
        <SummaryValue
          title={__('Cena s DPH')}
          value={formatPriceToString(totalPrice, currency)}
        />
      </BottomWrapper>
    </Wrapper>
  );
}
const Wrapper = styled(FlexCol)`
  width: 100%;
  max-width: ${rem(1048)};
  margin-left: 0;
  margin-right: auto;

  ${({ theme }) => theme.mediab.l925`
    padding-top: ${rem(32)};
  `}
`;

const BottomWrapper = styled(FlexCol)`
  margin-left: auto;
  margin-top: ${rem(8)};

  ${({ theme }) => theme.mediab.m810`
    margin: 0 auto;
    width: 100%;
  `}
`;

const CreateOrderButton = styled(Button)`
  height: ${rem(48)};
  margin: ${rem(15)} 0 0;
  padding: ${rem(8)} ${rem(24)};
  width: ${rem(238)};
  background-color: ${({ theme }) => theme.colors.secondary};
  color: ${({ theme }) => theme.colors.black};
  font-size: ${rem(14)};
  border-radius: ${rem(2)};
  margin: ${rem(16)} 0;

  &:disabled {
    background-color: #dcd6d6;
  }

  ${({ theme }) => theme.mediab.m580`
    width: 100%;
  `}
`;

export { OrderDetail };
